import React, {useState} from 'react';
import {Link, useParams} from 'react-router-dom';
import {Check, Search, Slash, X} from 'react-feather';
import {adminGetBrokers, adminChangeBrokerHasSearchFeature} from "../../../services/api/admin";
import ConfirmationModal from "../../../components/Modal/ConfirmationModal";
import {AdminTable} from "../../../components/Admin/Common/AdminTable";
import {Button, TextInput} from "flowbite-react";
import SearchAndUpdateSearchFeatureBlock from "../../../components/Admin/Brokers/SearchAndUpdateSearchFeatureBlock";

function highlightText(input, text) {
    if (text.length === 0)
        return input;
    const reg = new RegExp(text, 'gi');
    return input.replace(reg, function (str) {
        return `<b>${str}</b>`;
    });
}

const HAS_SEARCH_FEATURE = 1

const headers = [
    {data: 'ID', classes: ""},
    {data: 'Name', classes: ""},
    {data: 'Is Active', classes: ""},
    {data: 'Has Search Feature'},
    {data: 'Website', classes: ""},
    {data: 'Remove Feature', classes: ""},
];

const BrokersSearchFeatureList = () => {
    const {page, per_page} = useParams();
    const [brokersFetched, setBrokersFetched] = useState(false);
    const [tableSearchTerm, setTableSearchTerm] = useState('');
    const [brokersPagination, setBrokersPagination] = useState({
        total: 0,
        count: 0,
        per_page: parseInt(per_page, 10) || 10,
        current_page: parseInt(page, 10) || 1,
        total_pages: 1
    });
    const [brokersData, setBrokersData] = useState([]);
    const [deleteBroker, setDeleteBroker] = useState(null);

    const fetchBrokers = async (pageNum = null, perPageNum = null, searchTerm = null) => {
        setBrokersFetched(false);
        try {
            const currentPage = pageNum !== null ? pageNum : brokersPagination.current_page;
            const currentPerPage = perPageNum !== null ? perPageNum : brokersPagination.per_page;
            const currentSearchTerm = searchTerm !== null ? searchTerm : tableSearchTerm;

            const {data, meta} = await adminGetBrokers({
                page: currentPage,
                per_page: currentPerPage,
                term: currentSearchTerm,
                filters: {
                    has_search_feature: HAS_SEARCH_FEATURE,
                }
            });
            const transformedData = data.map((item) => ({
                id: {data: <Link to={"/admin/brokers/" + item.id}>{item.id}</Link>},
                name: {
                    data: <span
                        dangerouslySetInnerHTML={{__html: highlightText(item.name, currentSearchTerm)}}/>
                },
                is_active: {data: item.is_active ? 'True' : 'False'},
                searchfeature: {data: item.has_search_feature ? <Check/> : <Slash/>},
                website: {data: item.website},
                removeFlag: {
                    data: <X className={"sl-cursor-pointer"} onClick={() => setDeleteBroker(item)}/>
                },

            }));

            setBrokersFetched(true);
            setBrokersData(transformedData);
            setBrokersPagination(meta.pagination);

        } catch (e) {
            console.error('Error fetching conversations:', e);
            setBrokersFetched(true);
        }
    }

    React.useEffect(() => {
            if (!brokersData.length && !brokersFetched)
                fetchBrokers().then(r => console.log('r', r));
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [brokersData, brokersFetched]);

    React.useEffect(() => {
            setBrokersFetched(false);
            setBrokersData([]);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [page, per_page]);

    const tableSearchBrokersByTerm = () => {
        fetchBrokers(1, brokersPagination.per_page, tableSearchTerm);
    }

    const handlePageChange = (newPage) => {
        fetchBrokers(newPage, brokersPagination.per_page, tableSearchTerm);
    }

    const handleFlagUpdate = async (id = null, checked = true) => {
        try {
            await adminChangeBrokerHasSearchFeature(id, checked);
            setDeleteBroker(null);
            setTableSearchTerm('');
            await fetchBrokers(1, brokersPagination.per_page, '');

        } catch (e) {
            console.error('Error updating search feature flag:', e);
        }
    }

    return (
        <div>
            {deleteBroker && <ConfirmationModal
                title={`Remove Search UX Feature for : ${deleteBroker.name}`}
                message={`Are you sure you want to remove the Search UX feature from this Broker?`}
                handleConfirm={() => handleFlagUpdate(deleteBroker.id, false)}
                handleClose={() => {
                    setDeleteBroker(null);
                }}
            />}

            <main className="sl-main sl-mt-8">
                <div className="sl-container sl-m-auto sl-my-8">
                    <h1>Brokers - Discover Search UX</h1>
                    <SearchAndUpdateSearchFeatureBlock handleFlagUpdate={handleFlagUpdate}/>


                    <div className={"flex flex-row gap-1 sl-mt-8  sl-mb-2"}>
                        <TextInput
                            value={tableSearchTerm}
                            onChange={(e) => {
                                setTableSearchTerm(e.target.value)
                            }}
                            className={"sl-w-120"}
                            type="text" sizing="md" placeholder={'Enter Broker name to search ...'}/>

                        <Button size="md" isProcessing={!brokersFetched} onClick={tableSearchBrokersByTerm}
                                color={"light"}>
                            {brokersFetched && <Search size={16}/>}
                        </Button>
                    </div>
                    <AdminTable
                        dataFetched={brokersFetched}
                        headers={headers}
                        data={brokersData}
                        paginationData={brokersPagination}
                        basePath={`/admin/brokers/searchfeature`}
                        paginator={brokersPagination}
                        onPageChange={handlePageChange}
                    />
                </div>
            </main>
        </div>
    );
};

export default BrokersSearchFeatureList;
